import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import React, { FC } from 'react';

interface IProps {
	children: React.ReactNode;
	onClick: () => void;
}

const BackButton: FC<IProps> = ({ onClick, children }) => {
	return (
		<Button
			onClick={onClick}
			startIcon={<ArrowBack />}
			variant='text'
			color='inherit'
			size='large'
			sx={(theme) => ({
				height: '48px',
				marginRight: 'auto',
				color: theme.palette.secondary.main,
				minWidth: '200px',
				maxWidth: '200px',
				[theme.breakpoints.down('md')]: {
					minWidth: 'initial',
					maxWidth: 'unset',
				},
			})}
		>
			{children}
		</Button>
	);
};

export default BackButton;
